import type { MarkdownPreviewProps } from "@uiw/react-markdown-preview";
import { createBlockquoteRenderer } from "./components/BlockquoteRenderer/BlockquoteRenderer";
import type { IAlertConfig } from "./components/BlockquoteRenderer/BlockquoteRenderer";
import { createHeadingRenderers } from "./components/HeadingRenderers/HeadingRenderers";
import { createImageRenderer } from "./components/ImageRenderer/ImageRenderer";
import { createLinkRenderer } from "./components/LinkRenderer/LinkRenderer";
import { createListItemRenderer } from "./components/ListItemRenderer/ListItemRenderer";
import { createMediaRenderers } from "./components/MediaRenderers/MediaRenderers";
import { createTableRenderer } from "./components/TableRenderer/TableRenderer";

interface ICreateMarkdownComponentsProps {
  t: (key: string) => string;
  onCopyLink?: (sectionId: string) => void;
  copiedSectionId?: string | null;
  expandTableLabel: string;
  setExpandedTableProps: (tableProps: React.TableHTMLAttributes<HTMLTableElement> | null) => void;
  resolveMediaUrl: (url: string | undefined) => string | undefined;
  openExpandedImage: (src: string, alt: string) => void;
  alertConfigs?: Record<string, IAlertConfig>;
}

export function createMarkdownComponents({
  t,
  onCopyLink,
  copiedSectionId,
  expandTableLabel,
  setExpandedTableProps,
  resolveMediaUrl,
  openExpandedImage,
  alertConfigs,
}: ICreateMarkdownComponentsProps): NonNullable<MarkdownPreviewProps["components"]> {
  return {
    ...createHeadingRenderers({ t, onCopyLink, copiedSectionId }),
    ...createTableRenderer({ expandTableLabel, setExpandedTableProps }),
    ...createLinkRenderer({ resolveMediaUrl }),
    ...createListItemRenderer(),
    ...createBlockquoteRenderer({ alertConfigs }),
    ...createImageRenderer({ resolveMediaUrl, openExpandedImage }),
    ...createMediaRenderers({ resolveMediaUrl }),
  };
}

